import { Dispatch } from 'redux'
import {
  apiMiddleware as oceanApiMiddleware,
  MiddlewareApiAction as OceanMiddlewareApiAction,
  ApiAction as OceanApiAction,
  createApiAction as OceanCreateApiAction,
} from '@ocean/api'
import {
  ErrorUtils as OceanErrorUtils,
  SessionUtils as OceanSessionUtils,
  ToastUtils,
} from '@ocean/utils'
import { RootState } from 'store'
import { ErrorUtils, SsoUtils, MobileNativeUtils } from 'utils'
import { clearSessionInfo } from 'core/session/slices/session'

export type ApiAction = OceanApiAction<RootState>

// TODO: Check maybe we can delete MiddlewareApiAction if we do typings for dispatch
export type MiddlewareApiAction = OceanMiddlewareApiAction<RootState>

export const handleInvalidSession = (errorMessage: string, dispatch: Dispatch) => {
  const sessionToken = OceanSessionUtils.getSessionToken()
  if (!sessionToken) return

  const localizedError = ErrorUtils.getErrorMessage({
    code: OceanErrorUtils.INVALID_SESSION_CODE,
    message: errorMessage,
  })
  // Show warning about invalid session
  const ssoMarker = SsoUtils.getSsoMarker()
  if (!ssoMarker) {
    ToastUtils.warning(localizedError, OceanErrorUtils.INVALID_SESSION_CODE)
  } else {
    SsoUtils.setInvalidSessionMarker()
  }
  // Tell the mobile application about an invalid session
  MobileNativeUtils.sessionExpired()
  // Clear session info, logout and redirect to login
  dispatch<any>(clearSessionInfo({ needReturnUrl: true }))
}

export const apiMiddleware = oceanApiMiddleware({
  invalidSessionHandler: handleInvalidSession,
  getErrorMessage: ErrorUtils.getErrorMessage,
})

export const createApiAction = (actionParams: ApiAction): MiddlewareApiAction =>
  OceanCreateApiAction<RootState>(actionParams)
